import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { getFileInfoRequestUrlOneDrivePro } from './getFileInfoRequestUrlOneDrivePro';
import { getFileInfoRequestUrlOneDriveConsumer } from './getFileInfoRequestUrlOneDriveConsumer';
import {
    FetchRequestOptions,
    fetchService,
    CORS_MODE_NAME,
    GET_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';

export async function getFileInfo(
    url: string,
    attachmentDataProviderType:
        | AttachmentDataProviderType.OneDrivePro
        | AttachmentDataProviderType.OneDriveConsumer
): Promise<string> {
    let requestUrl: string;
    switch (attachmentDataProviderType) {
        case AttachmentDataProviderType.OneDrivePro:
            requestUrl = getFileInfoRequestUrlOneDrivePro(url);
            break;
        case AttachmentDataProviderType.OneDriveConsumer:
            requestUrl = getFileInfoRequestUrlOneDriveConsumer(url);
            break;
        default:
            throw new Error(`getFileInfo is not supported for ${attachmentDataProviderType}.`);
    }

    const requestOptions: FetchRequestOptions = {
        method: GET_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: null,
        datapointNamePrefix: 'GetFileInfo_' + attachmentDataProviderType.toString(),
    };

    const responseText: string = await fetchService(
        attachmentDataProviderType,
        requestUrl,
        null,
        requestOptions
    );
    return responseText;
}
